(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/pix-handler/pix/create-pix-handler.js') >= 0) return;  svs.modules.push('/components/sport/pix-handler/pix/create-pix-handler.js');

'use strict';

function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != typeof t || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
const logger = new svs.core.log.Logger('svs.components.sport.pixHandler.pix.createPixHandler');
const _svs$components$sport = svs.components.sport.pixHandler.productTypes,
  PixProductType1x2 = _svs$components$sport.PixProductType1x2,
  PixProductTypeNumberBoard = _svs$components$sport.PixProductTypeNumberBoard;
const _svs$components$sport2 = svs.components.sport.pixHandler.productTypes.products,
  PixProductBomben = _svs$components$sport2.PixProductBomben,
  PixProductRacing = _svs$components$sport2.PixProductRacing,
  PixProductChallenge = _svs$components$sport2.PixProductChallenge,
  PixProductMatchen = _svs$components$sport2.PixProductMatchen;
const PixData = svs.components.sport.pixHandler.pix.PixData;
const createPixDataKey = svs.components.sport.pixHandler.common.helpers.createPixDataKey;
const createWager = svs.components.payment.createWager.createWager;
const oneXTwoToBinary = svs.components.payment.createWager.utils.oneXTwoToBinary;
const _svs$components$sport3 = svs.components.sport.pixHandler.common.constants.QUICKPICK_PROPS,
  WEIGHTEDQP = _svs$components$sport3.WEIGHTEDQP,
  XPERTEN = _svs$components$sport3.XPERTEN;
const PIXMIX = svs.components.sport.pixHandler.common.constants.ADDITIONAL_CACHE_KEYS.PIXMIX;
const KEEP_OPEN_CACHE_KEY = svs.components.sport.pixHandler.common.constants.KEEP_OPEN_CACHE_KEY;
const splitBombenExpertenBoardDataToRows = svs.components.sport.expandedSystems.splitBombenExpertenBoardDataToRows;
const cache = svs.components.sport.pixHandler.common.cache;
const _svs$utils$products$p = svs.utils.products.productIds,
  BOMBEN = _svs$utils$products$p.BOMBEN,
  MALTIPSET = _svs$utils$products$p.MALTIPSET,
  T8 = _svs$utils$products$p.T8,
  T8EXTRA = _svs$utils$products$p.T8EXTRA,
  T8STRYK = _svs$utils$products$p.T8STRYK,
  EUROPATIPSET = _svs$utils$products$p.EUROPATIPSET,
  STRYKTIPSET = _svs$utils$products$p.STRYKTIPSET,
  CHALLENGE = _svs$utils$products$p.CHALLENGE,
  POWERPLAY = _svs$utils$products$p.POWERPLAY,
  MATCHEN = _svs$utils$products$p.MATCHEN,
  RACING = _svs$utils$products$p.RACING;
var _cache = new WeakMap();
var _products = new WeakMap();
var _cachedPixData = new WeakMap();
var _isPixMix = new WeakMap();
class PixHandler {
  constructor(_ref) {
    let isPixMix = _ref.isPixMix;
    _classPrivateFieldInitSpec(this, _cache, cache);
    _classPrivateFieldInitSpec(this, _products, new Map());
    _classPrivateFieldInitSpec(this, _cachedPixData, new Map());
    _classPrivateFieldInitSpec(this, _isPixMix, false);
    _defineProperty(this, "fetch", async _ref2 => {
      let productId = _ref2.productId,
        shouldGenerateNewPix = _ref2.shouldGenerateNewPix;
      const _classPrivateFieldGet2 = _classPrivateFieldGet(_products, this).get(productId),
        drawNumber = _classPrivateFieldGet2.drawNumber,
        systemCost = _classPrivateFieldGet2.systemCost,
        systemType = _classPrivateFieldGet2.systemType;
      const url = _classPrivateFieldGet(_products, this).get(productId).getURL();
      const additionalCacheKey = _classPrivateFieldGet(_isPixMix, this) ? PIXMIX : '';
      const pixDataKey = createPixDataKey(productId, drawNumber, systemCost, systemType, additionalCacheKey);
      let pixData = _classPrivateFieldGet(_cachedPixData, this).get(pixDataKey);
      if (!pixData || shouldGenerateNewPix) {
        pixData = await new PixData({
          productId,
          drawNumber,
          systemCost,
          systemType,
          additionalCacheKey,
          shouldGenerateNewPix,
          url
        });
        _classPrivateFieldGet(_cachedPixData, this).set(pixDataKey, pixData.cachedPixData);
      }
      return _classPrivateFieldGet(_cachedPixData, this);
    });
    _classPrivateFieldSet(_isPixMix, this, isPixMix);
  }
  get isPixMix() {
    return _classPrivateFieldGet(_isPixMix, this);
  }
  addProduct(productId, callback) {
    let pixProduct;
    switch (productId) {
      case T8:
      case T8STRYK:
      case T8EXTRA:
      case POWERPLAY:
      case EUROPATIPSET:
      case STRYKTIPSET:
        pixProduct = new PixProductType1x2(productId);
        break;
      case MALTIPSET:
        pixProduct = new PixProductTypeNumberBoard(productId);
        break;
      case BOMBEN:
        pixProduct = new PixProductBomben(productId);
        break;
      case MATCHEN:
        pixProduct = new PixProductMatchen(productId);
        break;
      case RACING:
        pixProduct = new PixProductRacing(productId);
        break;
      case CHALLENGE:
        pixProduct = new PixProductChallenge(productId);
        break;
      default:
        throw new Error("Support for productId: ".concat(productId, " not implemented yet"));
    }
    _classPrivateFieldGet(_products, this).set(productId, pixProduct);
    callback(pixProduct);
    return this;
  }
  getProduct(productId) {
    return _classPrivateFieldGet(_products, this).get(productId);
  }
  createPixWager(_ref3) {
    let productId = _ref3.productId,
      subProductId = _ref3.subProductId,
      _ref3$bagType = _ref3.bagType,
      bagType = _ref3$bagType === void 0 ? 0 : _ref3$bagType;
    const _this$getProduct = this.getProduct(productId),
      rowPrice = _this$getProduct.rowPrice,
      drawNumber = _this$getProduct.drawNumber;
    const _this$compose = this.compose(productId),
      boardData = _this$compose.boardData;
    const wager = createWager().addBet(productId, bet => {
      bet.setDrawNumber(drawNumber);
      switch (productId) {
        case EUROPATIPSET:
        case STRYKTIPSET:
        case POWERPLAY:
        case CHALLENGE:
        case T8:
        case T8EXTRA:
        case T8STRYK:
          {
            bet.setRowPrice(rowPrice).addBoard(board => {
              boardData.forEach(row => board.addOutcomes(oneXTwoToBinary(row)).addBoardProperty(WEIGHTEDQP));
            });
            if (subProductId) {
              bet.setSubProductId(subProductId);
            }
            break;
          }
        case MALTIPSET:
          {
            bet.setRowPrice(rowPrice);
            boardData.forEach(row => {
              bet.addBoard(board => board.addOutcomes(row).addBoardProperty(WEIGHTEDQP));
            });
            break;
          }
        case RACING:
          {
            const _this$getProduct2 = this.getProduct(productId),
              systemType = _this$getProduct2.systemType;
            bet.setRowPriceMulti(boardData.rowPriceMulti).setSystemType(boardData.rxBoards[0].systemType).setSubProductId(systemType).addBoard(board => board.addOutcomes(boardData.rxBoards).setRowCount(boardData.numRows));
            break;
          }
        case BOMBEN:
          {
            bet.addBetProperty(XPERTEN);
            const rows = splitBombenExpertenBoardDataToRows(boardData);
            rows.forEach(row => {
              const singleRow = [];
              while (row.length > 0) {
                const eventSigns = row.splice(0, 2);
                singleRow.push(eventSigns);
              }
              if (row.length === 0) {
                bet.addBoard(board => {
                  singleRow.forEach(eventSigns => board.addOutcomes([eventSigns[0]], [eventSigns[1]]));
                });
              }
            });
            break;
          }
        case MATCHEN:
          {
            bet.addBetProperty(XPERTEN).setRowPrice(rowPrice);
            const rows = splitBombenExpertenBoardDataToRows(boardData);
            rows.forEach(row => {
              const singleRow = [];
              while (row.length > 0) {
                const eventSigns = row.splice(0, 2);
                singleRow.push(eventSigns);
              }
              if (row.length === 0) {
                bet.addBoard(board => {
                  singleRow.forEach(eventSigns => board.addOutcomes([eventSigns[0]], [eventSigns[1]]));
                });
              }
            });
            break;
          }
        default:
          {
            logger.info("unsupported productId(".concat(productId, ") when creating wager"));
          }
      }
    }).setBagType(bagType);
    return wager;
  }
  get keepOpenItem() {
    return _classPrivateFieldGet(_cache, this).getData({
      itemKey: KEEP_OPEN_CACHE_KEY
    });
  }
  setKeepOpenItem(keepOpenItem) {
    _classPrivateFieldGet(_cache, this).setData({
      itemKey: KEEP_OPEN_CACHE_KEY,
      data: keepOpenItem
    });
  }
  unsetKeepOpenItem() {
    _classPrivateFieldGet(_cache, this).unsetData({
      itemKey: KEEP_OPEN_CACHE_KEY
    });
  }
  getModel(productId) {
    const _ref4 = _classPrivateFieldGet(_products, this).get(productId) || {},
      drawNumber = _ref4.drawNumber,
      systemCost = _ref4.systemCost,
      systemType = _ref4.systemType;
    const additionalCacheKey = _classPrivateFieldGet(_isPixMix, this) ? PIXMIX : '';
    const pixDataKey = createPixDataKey(productId, drawNumber, systemCost, systemType, additionalCacheKey);
    const pixData = _classPrivateFieldGet(_cachedPixData, this).get(pixDataKey);
    if (!pixData) {
      return;
    }
    return _classPrivateFieldGet(_products, this).get(productId).signs(pixData);
  }
  compose(productId) {
    const _ref5 = _classPrivateFieldGet(_products, this).get(productId) || {},
      drawNumber = _ref5.drawNumber,
      systemCost = _ref5.systemCost,
      systemType = _ref5.systemType;
    const additionalCacheKey = _classPrivateFieldGet(_isPixMix, this) ? PIXMIX : '';
    const pixDataKey = createPixDataKey(productId, drawNumber, systemCost, systemType, additionalCacheKey);
    const pixData = _classPrivateFieldGet(_cachedPixData, this).get(pixDataKey);
    if (!pixData) {
      return;
    }
    return _classPrivateFieldGet(_products, this).get(productId).board(pixData);
  }
}
const createPixHandler = _ref6 => {
  let isPixMix = _ref6.isPixMix;
  return new PixHandler({
    isPixMix
  });
};
setGlobal('svs.components.sport.pixHandler.pix.createPixHandler', createPixHandler);

 })(window);